import React from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './ExtendedRow.styles';

import AddTitle from '../../../forms/addtitle/AddTitle';
import Icon from '../../../common/icon/Icon';

const ExtendedRow = props => {
  let data = [];
  const {styles: customStyle} = props;
  if(props.data){
    data = [
      {
        name: I18n.t('models.tag.mac'),
        value: props.data.macAddress
      }
    ]
  }
  return (
    <div className={css(styles.container,customStyle)}>
      {props.data && (
        <AddTitle
          showData={true}
          data={data}
        />
      )}

      
      {props.data &&
        props.data.isSuperTag && (
          <Icon
            value="history"
            styles={styles.history}
            onClick={() => props.showHistory()}
          />
        )}
    </div>
  );
};

export default ExtendedRow;



// WEBPACK FOOTER //
// ./src/components/data/datatable/extendedrow/ExtendedRow.js